/**
 * Formats a pod position string into a human-readable title.
 * e.g. PREROLL → Pre-Roll, MIDROLL_02 → Mid-Roll_02, POSTROLL → Post-Roll
 */
export const formatPodPositionTitle = (podPosition: string): string => {
  const [rollPart, ...suffixParts] = podPosition.split('_');
  const formatted = rollPart.replace(/^(.+)(ROLL)$/i, (_, prefix, roll) => {
    const formattedPrefix = prefix.charAt(0).toUpperCase() + prefix.slice(1).toLowerCase();
    const formattedRoll = roll.charAt(0).toUpperCase() + roll.slice(1).toLowerCase();
    return `${formattedPrefix}-${formattedRoll}`;
  });
  const suffix = suffixParts.length > 0 ? `_${suffixParts.join('_')}` : '';
  return `${formatted}${suffix}`;
};
